// extracted by mini-css-extract-plugin
module.exports = {"container":"_1EiHfg9","mobile":"_3vHfvH4","scroll":"_38C1U5K","header":"_1_VTF0m","button":"_3J0AvbZ","right":"_1qv1IRp","gameList":"_2G4xwHR"};